import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=5a1b3314&scoped=true&"
import script from "./PhotoPreview.vue?vue&type=script&lang=js&"
export * from "./PhotoPreview.vue?vue&type=script&lang=js&"
import style0 from "./PhotoPreview.vue?vue&type=style&index=0&id=5a1b3314&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1b3314",
  null
  
)

export default component.exports